<div class="mb-5 grid w-full">
  <app-tab-group *ngIf="!bookContent.formato_apresentacao; else list" (activeId)="getIndexSubject($event)">
    <app-tab
      #tab
      *ngFor="let subject of bookContent.contents; let index = index"
      [id]="index"
      [active]="index === subjectActive"
    >
      <button app-tab-header type="button" [ngStyle]="tabStyle(subject, tab)" class="min-w-max text-sm uppercase">
        {{ subject.title }}
      </button>

      <ng-template app-tab-content>
        <div app-tab-content class="bg-white p-5 shadow">
          <ng-container
            [ngTemplateOutlet]="listAccordion"
            [ngTemplateOutletContext]="{
              valid: !!subject.contents[0].contents.length,
              data: subject,
              color: subject.color,
            }"
          ></ng-container>
        </div>
      </ng-template>
    </app-tab>
  </app-tab-group>

  <ng-template #list>
    <app-card>
      <div app-card-content>
        <ng-container
          [ngTemplateOutlet]="listAccordion"
          [ngTemplateOutletContext]="{ valid: !!bookContent.contents[0].contents.length, data: bookContent }"
        ></ng-container>
      </div>
    </app-card>
  </ng-template>
</div>

<ng-template #listAccordion let-data="data" let-color="color" let-valid="valid">
  <app-accordion class="w-full" *ngIf="valid">
    <app-accordion-item
      #item
      headerClass="border bg-[{{ item.expanded ? '${color ?? data?.color ?? level2.color}/40' : '' }}]"
      *ngFor="let level2 of data.contents; let index = index"
      [expanded]="index === (bookContent.formato_apresentacao === 0 ? chapterActive$.value : subjectActive)"
      (click)="setBookSummaryProject(color ?? data?.color ?? level2?.color, level2, index, level2?.page, $event)"
    >
      <div app-accordion-header>
        <div class="flex flex-row">
          <svg-icon
            src="assets/icons/icon-front-folder.svg"
            class="mr-8 h-3 w-3"
            [style.color]="color ?? data?.color ?? level2.color"
          ></svg-icon>
          <span class="font-semibold">{{ level2.title }}</span>
          <ng-container *ngIf="!!level2.total_files">
            <svg-icon
              src="assets/icons/icon-clip.svg"
              class="ml-4 mr-2 mt-1 h-4 w-4"
              [style.color]="color ?? data?.color ?? level2.color"
            ></svg-icon>
            {{ level2.total_files }}
          </ng-container>
          <svg-icon
            src="assets/icons/icon-unlocked.svg"
            class="ml-2 mr-2 mt-1 h-4 w-4 text-base-unlock-500"
            *ngIf="bookContent.has_lock"
          ></svg-icon>
        </div>
      </div>
      <ng-template app-accordion-lazy>
        <div app-accordion-content class="mb-2">
          <ng-container
            [ngTemplateOutlet]="listContent"
            [ngTemplateOutletContext]="{ data: level2.contents, color: color ?? data?.color ?? level2.color }"
          ></ng-container>
        </div>
      </ng-template>
    </app-accordion-item>
  </app-accordion>

  <ng-container
    *ngIf="!valid"
    [ngTemplateOutlet]="listContent"
    [ngTemplateOutletContext]="{ data: data.contents, color: color ?? data?.color }"
  ></ng-container>
</ng-template>

<ng-template #listContent let-data="data" let-color="color" let-space="space">
  <ng-container *ngFor="let content of data">
    <div
      class="flex flex-row"
      (click)="setBookSummaryProject(color ?? content.color, content, undefined, content?.page, $event)"
      [ngClass]="{ 'cursor-pointer': (!showModal && !!content.total_files) || (showModal && content?.page) }"
    >
      <svg-icon
        class="w-4 h-4 mt-1 text-[{{ color ?? content.color }}]"
        [style.color]="color ?? content?.color"
        [style.margin-left.px]="space ? space * 12 : 12"
        [src]="
          !!content?.contents?.length
            ? 'assets/icons/icon-align-collapse.svg'
            : 'assets/icons/icon-highlighter-rounded.svg'
        "
      ></svg-icon>
      <span class="ml-3">{{ content.title }}</span>
      <ng-container *ngIf="!!content.total_files">
        <svg-icon src="assets/icons/icon-clip.svg" class="ml-4 mr-2 mt-1 h-4 w-4"></svg-icon>
        {{ content.total_files }}
      </ng-container>
      <svg-icon
        src="assets/icons/icon-unlocked.svg"
        class="ml-3 mr-2 mt-1 h-4 w-4 text-base-unlock-500"
        *ngIf="bookContent.has_lock"
      ></svg-icon>
    </div>

    <ng-container
      *ngIf="!!content?.contents?.length"
      [ngTemplateOutlet]="listContent"
      [ngTemplateOutletContext]="{ data: content.contents, color: color ?? data.color, space: space ? space + 1 : 2 }"
    ></ng-container>
  </ng-container>
</ng-template>
